"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FraudFlag = void 0;
var FraudFlag;
(function (FraudFlag) {
    let flag;
    (function (flag) {
        flag["EVENT_CCV_RATIO"] = "event_ccv_ratio";
        flag["DEEPER_EVENT_RATIO"] = "deeper_event_ratio";
        flag["SPEED"] = "speed";
        flag["OFFLINE_EVENTS"] = "offline_events";
        flag["SAME_TIME_EVENTS"] = "same_time_events";
        flag["EVENTS_CLICKS_RATIO"] = "events_clicks_ratio";
        flag["EVENTS_UNIQUE_CLICKS_RATIO"] = "events_unique_clicks_ratio";
    })(flag = FraudFlag.flag || (FraudFlag.flag = {}));
})(FraudFlag = exports.FraudFlag || (exports.FraudFlag = {}));
